import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_chevron_right: SvgIconData = {
  viewBox: '0 0 9 14',
  element: (
    <path
      d="M1.5 1.16665L7.33333 6.99998L1.5 12.8333"
      stroke={`${TEXT_MAIN_COLOR}60`}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
